import { mobileApiRequest } from '../../apiRequests'

export const getSlackConnection = async (connectionKey) => {
    const action = {
        action: 'getObject',
        class: 'scoop.connector.APIConnection',
        key: connectionKey,
    }

    return await mobileApiRequest(action)
}

export const getSlackChannels = async (connectionKey) => {
    const action = {
        action: 'getSlackChannels',
        connectionKey,
    }

    return await mobileApiRequest(action)
}

export const getSlackChannelDataset = async (inboxID) => {
    const action = {
        action: 'getObjects',
        class: 'scoop.slack.models.SlackChannelDataset',
        attributeName: 'inboxID',
        attributeValue: inboxID,
    }

    return await mobileApiRequest(action)
}

export const addDatasetToChannel = async (slackTeamID, slackChannelID, inboxID) => {
    const action = {
        action: 'putObject',
        class: 'scoop.slack.models.SlackChannelDataset',
        value: {
            slackTeamID,
            slackChannelID,
            inboxID,
        },
    }

    return await mobileApiRequest(action)
}

export const removeDatasetFromChannel = async (slackChannelID, inboxID) => {
    const action = {
        action: 'deleteObject',
        class: 'scoop.slack.models.SlackChannelDataset',
        keyParts: [slackChannelID, inboxID],
    }

    return await mobileApiRequest(action)
}

export const getSlackOAuthUrl = async () => {
    const action = {
        action: 'getAPIFeatures',
        connectionType: 'Slack',
    }

    return await mobileApiRequest(action)
}

export const disconnectSlack = async (connectionKey) => {
    const action = {
        action: 'disconnectSlack',
        connectionKey,
    }

    return await mobileApiRequest(action)
}
